
<div class="form-input-container" [style]="style">

@if (readonly) {
  <label>{{label}}</label>
  <div  #container>
    <select class="floatSelect" [(ngModel)]="boundValue"  [disabled]="true">
      @for (item of options; track item) {
        <option [value]="item.id">{{item.name}}</option>
      }
    </select>      
  </div>
}
  
@if (!readonly) {
    <label>{{label}}</label>
    <div  #container>
        <select [hidden]="multiple" class="form-input" id="{{myId}}" #ddl [(ngModel)]="boundValue" [class.is-invalid]="!isValid" (change)="_handle_change($event)" (blur)="_handle_onBlur($event)" >
            @for (item of options; track item) {
            <option [value]="item.id">{{item.name}}</option>
            }
        </select>
        <select [hidden]="!multiple" class="form-input" multiple id="{{myId}}" #ddl [class.is-invalid]="!isValid" [(ngModel)]="boundValue" (change)="_handle_change($event)" (blur)="_handle_onBlur($event)" >
            @for (item of options; track item) {
            <option [value]="item.id">{{item.name}}</option>
            }
        </select>
        <!-- @if (helpText != '') {
            <mat-icon class="iconOverlay" matTooltip="{{helpText}}" [ngStyle]="{'color':'#6b7475'}">info</mat-icon>
        } -->
        <!-- <div *ngIf="helpText != ''" class="helpOverlay" (mouseover)="showHelp($event);">?</div>
        <div *ngIf="helpVisible && helpText != ''" id="{{myId}}_h" (mouseout)="hideHelp($event)" (click)="$event.stopPropagation()" class="contextHelpBox">
            {{helpText}}
        </div> -->
        <div class="validation-msg" [hidden]="isValid">{{validationMsg}}</div>
    </div>
}

</div>